/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateUserBirthDateRequestUser
 */
export interface UpdateUserBirthDateRequestUser {
    /**
     * 
     * @type {Date}
     * @memberof UpdateUserBirthDateRequestUser
     */
    birthDate: Date;
}

/**
 * Check if a given object implements the UpdateUserBirthDateRequestUser interface.
 */
export function instanceOfUpdateUserBirthDateRequestUser(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "birthDate" in value;

    return isInstance;
}

export function UpdateUserBirthDateRequestUserFromJSON(json: any): UpdateUserBirthDateRequestUser {
    return UpdateUserBirthDateRequestUserFromJSONTyped(json, false);
}

export function UpdateUserBirthDateRequestUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserBirthDateRequestUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'birthDate': (new Date(json['birth_date'])),
    };
}

export function UpdateUserBirthDateRequestUserToJSON(value?: UpdateUserBirthDateRequestUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'birth_date': (value.birthDate.toISOString().substr(0,10)),
    };
}

